module.exports = __webpack_public_path__ + "static/media/medStaff2.00dbf219.jpg";